<template>
  <nav class="navbar">
    <div class="navbar-container" :class="{ 'admin-style': $route.meta.isAdminNav }">
      <!-- Hamburger Menu (mobile only) -->
      <button class="hamburger-menu" @click="toggleSidebar" aria-label="Menu">
        <span :class="{ open: showSidebar }"></span>
        <span :class="{ open: showSidebar }"></span>
        <span :class="{ open: showSidebar }"></span>
      </button>

      <!-- Logo -->
      <router-link to="/" class="logo">
        <img src="/logo-lion.png" class="logo">
        <span>
          {{ settingsStore.appName.slice(0, -2) }}<span style="color: #37633F">{{ settingsStore.appName.slice(-2)
          }}</span>
        </span>
      </router-link>

      <!-- Badge DEV (visible uniquement en développement) -->
      <div v-if="isDev" class="dev-badge">
        DEVELOPPEMENT
      </div>

      <!-- Menu Desktop -->
      <ul class="nav-menu">

        <!-- Dropdown pays (desktop) -->
        <li v-if="!userStore.user" class="dropdown-wrapper countries" ref="countryDropdownRef">
          <button class="dropdown-trigger country-trigger" @click="showCountryMenu = !showCountryMenu">
            <span>{{ currentCountry?.flag }}</span>
            <span>{{ localeStore.countryIso }}</span>
          </button>
          <Transition name="dropdown">
            <ul v-if="showCountryMenu" class="suggestions country-suggestions">
              <li v-for="c in countries" :key="c.iso3" :class="{ active: c.iso3 === localeStore.countryIso }"
                @click="selectCountry(c)">
                <span>{{ c.flag }}</span>
                <span>{{ c.iso3 }}</span>
              </li>
            </ul>
          </Transition>
        </li>
        <li v-if="!userStore.user">
          <router-link :to="{ name: 'login' }">Se connecter</router-link>
          <span class="separator"> · </span>
          <router-link :to="{ name: 'register' }">S'inscrire</router-link>
        </li>
        <li v-else class="user-item">
          <button class="avatar" @click="toggleMenu" :class="{ active: showMenu }" :aria-expanded="showMenu"
            aria-haspopup="true" :aria-label="`Menu de ${userStore.user?.firstName}`" :style="userStore.user?.avatarName
              ? { backgroundImage: `url(${config.apiUrl}/uploads/avatars/${userStore.user.avatarName})` }
              : {}">
            <span v-if="!userStore.user?.avatarName">{{ getInitials(userStore.user) }}</span>
          </button>

          <!-- Dropdown sorti du bouton -->
          <Transition name="dropdown">
            <div v-if="showMenu" class="dropdown" @click.stop>
              <!--<router-link :to="{ name: 'search' }">Rechercher un trajet</router-link>-->
              <router-link :to="{ name: 'account' }">Mon compte</router-link>
              <router-link v-if="userStore.user?.roles?.includes('ROLE_ADMIN')" to="/admin"
                class="admin">Admin</router-link>
              <a href="#" @click.prevent="logout">Déconnexion</a>
            </div>
          </Transition>
        </li>
      </ul>

      <!-- Overlay -->
      <div class="sidebar-overlay" :class="{ active: showSidebar }" @click="closeSidebar"></div>

      <!-- Sidebar Mobile -->
      <div class="sidebar" :class="{ active: showSidebar }">

        <!-- Sidebar Header (Icon Zone) -->
        <div class="sidebar-header">

          <!-- Dropdown pays (mobile sidebar) -->
          <div v-if="!userStore.user" class="sidebar-country dropdown-wrapper" ref="sidebarCountryRef">
            <button class="dropdown-trigger" @click="showSidebarCountry = !showSidebarCountry">
              {{ currentCountry?.flag }} {{ localeStore.countryIso }}
            </button>
            <Transition name="dropdown">
              <ul v-if="showSidebarCountry" class="suggestions">
                <li v-for="c in countries" :key="c.iso3" :class="{ active: c.iso3 === localeStore.countryIso }"
                  @click="selectCountry(c); showSidebarCountry = false">
                  {{ c.flag }} {{ c.iso3 }}
                </li>
              </ul>
            </Transition>
          </div>

          <button type="button" class="theme-toggle-icon" @click="themeStore.toggleTheme" aria-label="Changer le thème">
            <svg v-if="themeStore.isDark" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
            </svg>
            <svg v-else xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="5"></circle>
              <line x1="12" y1="1" x2="12" y2="3"></line>
              <line x1="12" y1="21" x2="12" y2="23"></line>
              <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
              <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
              <line x1="1" y1="12" x2="3" y2="12"></line>
              <line x1="21" y1="12" x2="23" y2="12"></line>
              <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
              <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
            </svg>
          </button>

          <!-- Bouton déconnexion (visible uniquement si connecté) -->
          <button v-if="userStore.user" type="button" class="logout-icon" @click="logout" aria-label="Déconnexion">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
              <circle cx="8.5" cy="7" r="4"></circle>
              <line x1="18" y1="8" x2="23" y2="13"></line>
              <line x1="23" y1="8" x2="18" y2="13"></line>
            </svg>

          </button>
        </div>

        <ul class="sidebar-menu">
          <li>
            <router-link to="/" @click="closeSidebar">Rechercher un trajet</router-link>
          </li>
          <li>
            <router-link to="/download" @click="closeSidebar">Télécharger l'application</router-link>
          </li>
          <li v-if="!userStore.user">
            <router-link :to="{ name: 'login' }" @click="closeSidebar">Se connecter</router-link>
          </li>
          <li v-if="!userStore.user">
            <router-link :to="{ name: 'register' }" @click="closeSidebar">S'inscrire</router-link>
          </li>
          <li v-if="userStore.user">
            <router-link to="/account" @click="closeSidebar">Mon compte</router-link>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { useUserStore } from '../stores/userStore'
import { useModalStore } from '../stores/modalStore'
import { useRouter } from 'vue-router'
import { useThemeStore } from '../stores/themeStore'
import { useClickOutside } from '@/utils/useClickOutside'
import { useLocaleStore } from '@/stores/localeStore'
import { storeToRefs } from 'pinia'
import { config } from '@/config/env.js'
import { useSettingsStore } from '@/stores/settingsStore'

const settingsStore = useSettingsStore()
const isDev = import.meta.env.DEV
const themeStore = useThemeStore()
const modalStore = useModalStore()
const userStore = useUserStore()
const localeStore = useLocaleStore()
const router = useRouter()
const showMenu = ref(false)
const showSidebar = ref(false)

const showCountryMenu = ref(false)
const showSidebarCountry = ref(false)
const countryDropdownRef = ref(null)
const sidebarCountryRef = ref(null)
const { countries, currentCountry } = storeToRefs(localeStore)

const selectCountry = (c) => {
  localeStore.setCountry(c.iso3)
  showCountryMenu.value = false
  showSidebarCountry.value = false
}

const getInitials = (user) => {
  if (!user) return '?'

  const firstName = user.firstName || ''
  const lastName = user.lastName || ''

  const firstInitial = firstName.trim().charAt(0)
  const lastInitial = lastName.trim().charAt(0)

  const initials = `${firstInitial}${lastInitial}`.toUpperCase()

  return initials || '?'
}

const toggleMenu = () => {
  showMenu.value = !showMenu.value
}

const toggleSidebar = () => {
  showSidebar.value = !showSidebar.value
}

const closeSidebar = () => {
  showSidebar.value = false
}

const logout = async () => {
  const { result } = modalStore.open({
    kind: 'confirm',
    title: 'Déconnexion',
    message: "Voulez-vous vraiment vous déconnecter ?",
    confirmText: 'Valider',
    cancelText: 'Annuler'
  })

  const res = await result
  if (res.action === 'confirm') {
    userStore.logout()
    router.push('/')
    showMenu.value = false
    showSidebar.value = false
  }
}

const closeMenu = (e) => {
  if (!e.target.closest('.user-item')) {
    showMenu.value = false
  }
}

onMounted(() => document.addEventListener('click', closeMenu))
onBeforeUnmount(() => document.removeEventListener('click', closeMenu))
useClickOutside(countryDropdownRef, () => showCountryMenu.value = false)
useClickOutside(sidebarCountryRef, () => showSidebarCountry.value = false)

</script>

<style scoped>
.navbar {
  font-family: var(--font-family-title);
  position: sticky;
  top: 0;
  padding: 0.54rem 0;
  background-color: var(--bg-primary-alpha);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  box-shadow: var(--shadow-lg);
  z-index: 1000;
  width: 100%;
  min-height: 70px;
  display: flex;
  align-items: center;
}

.navbar-container {
  max-width: 80rem;
  margin: 0 auto;
  padding: 0 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.navbar-container a {
  font-family: var(--font-family-title);
  color: var(--color-feuille);
  text-decoration: none;
  transition: color 0.3s;
}

.navbar-container a:hover,
.nav-menu a.router-link-active {
  color: var(--color-jungle);
}

.logo {
  font-size: 1.5rem;
  font-weight: 800;
}

.nav-menu {
  display: flex;
  list-style: none;
  gap: 1rem;
  margin: 0;
  padding: 0;
  font-weight: 600;
  align-items: center;
}

/* --------- Avatar --------- */
.user-item {
  position: relative;
}

.avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--color-jungle), var(--color-feuille));
  color: var(--bg-primary);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-weight: 800;
  user-select: none;
  box-shadow: var(--shadow-sm);
  border: none;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

/* --------- Dropdown --------- */
.dropdown {
  position: absolute;
  top: 50px;
  right: 0;
  width: 240px;
  background: var(--bg-primary);
  border-radius: 14px;
  box-shadow: var(--shadow-lg);
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  z-index: 2000;
  margin-top: 10px;
}

.dropdown a {
  padding: 10px;
  border-radius: 10px;
  text-decoration: none;
  font-weight: 500;
}

.dropdown a:hover {
  background: var(--bg-black-alpha);
}

.suggestions.country-suggestions>li,
.dropdown-trigger.country-trigger {
  border: 0;
  display: flex;
  gap: 0.3rem;
}

/* --------- Animation --------- */
.dropdown-enter-active,
.dropdown-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.dropdown-enter-from,
.dropdown-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.avatar.active {
  box-shadow: var(--shadow-avatar-active);
}

/* --------- Hamburger Menu --------- */
.hamburger-menu {
  display: none;
  flex-direction: column;
  justify-content: space-around;
  width: 30px;
  height: 24px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 1001;
}

.hamburger-menu span {
  width: 100%;
  height: 3px;
  background-color: var(--color-feuille);
  border-radius: 10px;
  transition: all 0.3s ease;
  transform-origin: center;
}

.hamburger-menu span.open:nth-child(1) {
  transform: rotate(45deg) translateY(10px);
}

.hamburger-menu span.open:nth-child(2) {
  opacity: 0;
}

.hamburger-menu span.open:nth-child(3) {
  transform: rotate(-45deg) translateY(-10px);
}

/* --------- Sidebar --------- */
.sidebar {
  position: fixed;
  top: 0;
  left: -280px;
  width: 280px;
  height: 100vh;
  background: var(--bg-primary);
  box-shadow: var(--shadow-menu);
  transition: left 0.3s ease;
  z-index: 1002;
  overflow-y: auto;
}

.sidebar.active {
  left: 0;
}

/* --------- Sidebar Header (Icon Zone) --------- */
.sidebar-header {
  padding: 1.5rem 1rem;
  border-bottom: 1px solid var(--color-grey-light);
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 1rem;
}

.theme-toggle-icon {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-feuille);
  transition: opacity 0.2s;
}

.theme-toggle-icon:hover {
  opacity: 0.7;
}

.sidebar-menu {
  list-style: none;
  padding: 1rem;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.sidebar-menu li a {
  display: block;
  padding: 1rem;
  color: var(--color-grey-dark);
  text-decoration: none;
  border-radius: 10px;
  transition: background 0.2s;
  font-weight: 600;
  width: 100%;
  text-align: left;
}

.sidebar-menu li a:hover {
  background: var(--bg-black-alpha);
}

.sidebar-menu li a.router-link-active {
  background: var(--bg-black-alpha);
  color: var(--color-jungle);
}

.sidebar-logout {
  margin-top: auto;
  padding-top: 1rem;
  /* border-top: 1px solid var(--color-grey-light); */
}

.sidebar-logout a {
  color: #e74c3c;
}

/* --------- Overlay --------- */
.sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease, visibility 0.3s ease;
  z-index: 999;
}

.sidebar-overlay.active {
  opacity: 1;
  visibility: visible;
}

a {
  font-weight: 600;
}

.separator {
  color: var(--color-grey-medium);
  margin: 0 0.3rem;
  font-weight: 600;
}

.theme-toggle-icon,
.logout-icon {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-feuille);
  transition: opacity 0.2s;
}

.theme-toggle-icon:hover,
.logout-icon:hover {
  opacity: 0.7;
}

.logout-icon {
  color: var(--color-terracotta);
}

.admin-style {
  max-width: 100%;
}

/* --------- Media Queries --------- */
@media screen and (max-width: 768px) {

  img.logo {
    display: none;
  }

  .sidebar-country .dropdown-trigger {
    min-width: 80px;
  }

  .hamburger-menu {
    display: flex;
  }

  .logo {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }

  .nav-menu {
    display: none;
  }

  .navbar-container {
    padding-top: 0.3rem;
    padding-bottom: 0.3rem;
  }
}
</style>
